import Container from './container'

export default Container



// WEBPACK FOOTER //
// ./src/iss-cases/index.js